import {React, useState, useEffect} from "react";
import ScoresLiveCard from "components/common/ScoresLiveCard";
import { dateFormat } from "helpers/utils"
import Label from "components/general/Label";
import { isFinishedStatus } from "helpers/status";
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";
import { Link } from "react-router-dom";
import { Score as ScoreGlobal } from "components/presentation/Score"
import { getEventRSC } from "helpers/rsc";
import { faUnderline } from "@fortawesome/free-solid-svg-icons";
import useViewport from "components/general/useViewPort";


export function CardsLayout({ results }) {
        const { breakPoint } = useViewport();
    
        const isMobile = breakPoint === "sm" || breakPoint === "xs"
    
        const mat1 = [];
        const mat2 = [];
        const mat3 = [];
        results?.forEach(item => {
            if (item?.location?.code === 'WRA')
                mat1.push(item)
            else if (item?.location?.code === 'WRB')
                mat2.push(item)
            else if (item?.location?.code === 'WRC')
                mat3.push(item)
        })
    
        const session1 = results[0]?.session?.startDate
        const mat1session1 = [];
        const mat1session2 = [];
        const mat2session1 = [];
        const mat2session2 = [];
        const mat3session1 = [];
        const mat3session2 = [];
    
        mat1?.forEach(item => {
            if (item?.session?.startDate === session1)
                mat1session1.push(item)
            else if (item?.session?.startDate !== session1)
                mat1session2.push(item)
        })
    
        mat2?.forEach(item => {
            if (item?.session?.startDate === session1)
                mat2session1.push(item)
            else if (item?.session?.startDate !== session1)
                mat2session2.push(item)
        })

        mat3?.forEach(item => {
            if (item?.session?.startDate === session1)
                mat3session1.push(item)
            else if (item?.session?.startDate !== session1)
                mat3session2.push(item)
        })
    
        const mat1Finished = mat1?.filter(item => isFinishedStatus(item?.result?.status?.code))
        mat1Finished.sort(function (a, b) { return a - b });
        let last1Finished = mat1Finished.slice(-1)
    
        const mat2Finished = mat2?.filter(item => isFinishedStatus(item?.result?.status?.code))
        mat2Finished.sort(function (a, b) { return a - b });
        let last2Finished = mat2Finished.slice(-1)

        const mat3Finished = mat3?.filter(item => isFinishedStatus(item?.result?.status?.code))
        mat3Finished.sort(function (a, b) { return a - b });
        let last3Finished = mat3Finished.slice(-1)
    
        return (
            <>
                <div className="container scores-today-match">
                    <div className="scores-today-header">
                        <div className={isMobile ? '' : 'row'}>
                            <div className={isMobile ? '' : 'col-4'}>
                                {mat1session1.length !== 0 &&
                                    <>
                                        <div className="card scores-today-wre-location ">
                                            <div className="card-body d-flex justify-content-between">
                                                <div className="fw-bold">
                                                    {mat1session1[0]?.location?.shortDescription}
                                                </div>
                                                <div className='text-end'>
                                                    <Label data="HeaderStartAt" /> {dateFormat(mat1session1[0]?.session?.startDate, undefined, 'HH:mm')}
                                                </div>
                                            </div>
                                        </div>
                                        {results && mat1session1?.map(item => {
                                            if (isFinishedStatus(item?.result?.status?.code) && item?.eventUnit?.code !== last1Finished[0]?.eventUnit?.code)
                                                return ''
                                            else
                                                return <ScoresLiveCard data={item} key={item?.eventUnit?.code} />
                                        })}
                                    </>
                                }
                                {mat1session2.length !== 0 &&
                                    <>
                                        <div className="card scores-today-wre-location ">
                                            <div className="card-body d-flex justify-content-between">
                                                <div className="fw-bold">
                                                    {mat1session2[0]?.location?.shortDescription}
                                                </div>
                                                <div className='text-end'>
                                                    <Label data="HeaderStartAt" /> {dateFormat(mat1session2[0]?.session?.startDate, undefined, 'HH:mm')}
                                                </div>
                                            </div>
                                        </div>
                                        {results && mat1session2?.map(item => {
                                            if (isFinishedStatus(item?.result?.status?.code) && item?.eventUnit?.code !== last1Finished[0]?.eventUnit?.code)
                                                return ''
                                            else
                                                return <ScoresLiveCard data={item} key={item?.eventUnit?.code} />
                                        })}
                                    </>
                                }
                            </div>
                            <div className={isMobile ? '' : 'col-4'}>
                                {mat2session1.length !== 0 &&
                                    <>
                                        <div className="card scores-today-wre-location ">
                                            <div className="card-body d-flex justify-content-between">
                                                <div className="fw-bold">
                                                    {mat2session1[0]?.location?.shortDescription}
                                                </div>
                                                <div className='text-end'>
                                                    <Label data="HeaderStartAt" /> {dateFormat(mat2session1[0]?.session?.startDate, undefined, 'HH:mm')}
                                                </div>
                                            </div>
                                        </div>
                                        {results && mat2session1?.map(item => {
                                            if (isFinishedStatus(item?.result?.status?.code) && item?.eventUnit?.code !== last2Finished[0]?.eventUnit?.code)
                                                return ''
                                            else
                                                return <ScoresLiveCard data={item} key={item?.eventUnit?.code} />
                                        })}
                                    </>
                                }
                                {mat2session2.length !== 0 &&
                                    <>
                                        <div className="card scores-today-wre-location ">
                                            <div className="card-body d-flex justify-content-between">
                                                <div className="fw-bold">
                                                    {mat2session2[0]?.location?.shortDescription}
                                                </div>
                                                <div className='text-end'>
                                                    <Label data="HeaderStartAt" /> {dateFormat(mat2session2[0]?.session?.startDate, undefined, 'HH:mm')}
                                                </div>
                                            </div>
                                        </div>
                                        {results && mat2session2?.map(item => {
                                            if (isFinishedStatus(item?.result?.status?.code) && item?.eventUnit?.code !== last2Finished[0]?.eventUnit?.code)
                                                return ''
                                            else
                                                return <ScoresLiveCard data={item} key={item?.eventUnit?.code} />
                                        })}
                                    </>
                                }
                            </div>
                            <div className={isMobile ? '' : 'col-4'}>
                                {mat3session1.length !== 0 &&
                                    <>
                                        <div className="card scores-today-wre-location ">
                                            <div className="card-body d-flex justify-content-between">
                                                <div className="fw-bold">
                                                    {mat3session1[0]?.location?.shortDescription}
                                                </div>
                                                <div className='text-end'>
                                                    <Label data="HeaderStartAt" /> {dateFormat(mat3session1[0]?.session?.startDate, undefined, 'HH:mm')}
                                                </div>
                                            </div>
                                        </div>
                                        {results && mat3session1?.map(item => {
                                            if (isFinishedStatus(item?.result?.status?.code) && item?.eventUnit?.code !== last3Finished[0]?.eventUnit?.code)
                                                return ''
                                            else
                                                return <ScoresLiveCard data={item} key={item?.eventUnit?.code} />
                                        })}
                                    </>
                                }
                                {mat3session2.length !== 0 &&
                                    <>
                                        <div className="card scores-today-wre-location ">
                                            <div className="card-body d-flex justify-content-between">
                                                <div className="fw-bold">
                                                    {mat3session2[0]?.location?.shortDescription}
                                                </div>
                                                <div className='text-end'>
                                                    <Label data="HeaderStartAt" /> {dateFormat(mat3session2[0]?.session?.startDate, undefined, 'HH:mm')}
                                                </div>
                                            </div>
                                        </div>
                                        {results && mat3session2?.map(item => {
                                            if (isFinishedStatus(item?.result?.status?.code) && item?.eventUnit?.code !== last3Finished[0]?.eventUnit?.code)
                                                return ''
                                            else
                                                return <ScoresLiveCard data={item} key={item?.eventUnit?.code} />
                                        })}
                                    </>
                                }
                            </div>
                            
                        </div>
                    </div>
                </div>
            </>
        );
}

export function Header({ data }) {
    const unitNum = data?.result?.extendedInfos?.find(i => i?.ei_code === 'UNIT_NUMBER')?.ei_value;
    const testHH = dateFormat(data?.session?.startDate, undefined, 'HH:mm')
    let number = data?.result?.extendedInfos?.find(i => i?.ei_code === 'UNIT_NUMBER') ? data?.result?.extendedInfos?.find(i => i?.ei_code === 'UNIT_NUMBER')?.ei_value : ''


    return (
        <><div className='scores-today-header'>
            <div className='scores-today-piste-tte'>
                <div className='flex-grow-1'>
                    {data?.eventUnit?.description}
                </div>
                <div className='text-end'>
                    <Label data="HeaderMatch" />{' '+number}

                </div>
            </div>
        </div></>
    )
}

export function BodyComponent({ data, competitorComponent, competitorNoDataComponent }) {
    const CompetitorComponent = competitorComponent || <></>
    const CompetitorNoDataComponent = competitorNoDataComponent || <></>
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let paramsURL = { ...useUrlFriendlyToParameters() }
    const getURL = useGetURL()
    paramsURL["mirs_rsc"] = data?.eventUnit?.code
    if (!paramsURL["mirs_event"]) {
        paramsURL["mirs_event"] = getEventRSC(data?.eventUnit?.code)
    }
    const url = getURL({ ...paramsURL }, 'results')
    let sortedItems = Array.isArray(data?.result?.items) ? data?.result?.items.sort((a, b) => a.sortOrder - b.sortOrder) : undefined;
    const out = sortedItems?.map(item => {
        const isLeader = item?.extendedResults?.find(e=> e.er_code === 'LEADER' && e.er_value ==='Y')
        let color = item?.eventUnitEntries?.find(eventUnitEntry => eventUnitEntry?.eue_code === 'COLOUR')?.eue_value?.toLowerCase();
        return (<div className=" score-line d-flex flex-row "> 
            <Link key={item?.sortOrder} to={url} style={{width:'300px'}}>
                <div className=" score-line d-flex flex-row ">

                    <div className={"scores-today-wre-box m-1 uniform-color-" + color} />
                    {item?.participant ? <CompetitorComponent extendedInfos={data?.result?.extendedInfos} {...item} /> : <CompetitorNoDataComponent {...item} />}
                    {/** Results in match */}
                </div>
            </Link>
            <div className=" score-line d-flex flex-row " style={{textDecoration: isLeader ?'underline':''}}>
                <ScoreGlobal  competitorPos={item.sortOrder} resultJson={item?.resultDataText} discipline={mirs_discipline} extendedInfos={data?.result?.extendedInfos} />

            </div>
            </div>)
    })

    return (
        <>{out}</>
    )

}